import React, { useContext, useState, useEffect } from "react";
import "./SettingsInfos.scss";
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TextareaAutosize from "react-textarea-autosize";
import axios from "axios";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";

import { UserContext } from "../../api/user/userContext";

function SettingsInfos({ onLogin = () => {} }) {
  const { user, dispatchUser } = useContext(UserContext);
  const [ready, setReady] = useState(false);
  const [descriptionChanged, setDescriptionChanged] = useState(false);

  const [notifySubscriptions, setNotifySubscriptions] = useState(false);
  const [notifyComments, setNotifyComments] = useState(false);
  const [notifyReplays, setNotifyReplays] = useState(false);
  const [notificationsChanged, setNotificationsChanged] = useState(false);

  const notifySubscriptionsChanged = (evt) => {
    setNotifySubscriptions(!notifySubscriptions);
  };
  const notifyCommentsChanged = (evt) => {
    setNotifyComments(!notifyComments);
  };
  const notifyReplaysChanged = (evt) => {
    setNotifyReplays(!notifyReplays);
  };

  const [description, setDescription] = useState(null);
  const onDescriptionChanged = (evt) => {
    let value = evt.target.value;
    if (value.length > 500) {
      value = value.substring(0, 500);
    }
    console.log("description", value);
    setDescription(value);
    setDescriptionChanged(true);
  };

  const { t } = useTranslation();

  const handleDescriptionSubmit = (event) => {
    event.preventDefault();
    setReady(false);
    axios({
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      url: window.serverUrl+`/social/user-infos.php`,
      data: {
        field: "cb_description",
        value: description
      }
    })
      //.then((r) => r.json())
      .then((resp) => {
        let data = resp.data;
        if (data.error === 401) {
          onLogin();
        } else {
          setDescriptionChanged(false);
          onDescription(description);
        }
        setReady(true);
      })
      .catch((err) => {
        console.error("fetch problem", err);
        setReady(true);
        toast.error(t("settings.update_error"), {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: 0
        });
      });
  };

  const handleNotificationsSubmit = (event) => {
    event.preventDefault();
    setReady(false);

    let checked = [];
    if (notifySubscriptions) {
      checked[checked.length] = "subscriptions";
    }
    if (notifyComments) {
      checked[checked.length] = "comments";
    }
    if (notifyReplays) {
      checked[checked.length] = "replays";
    }
    let value = checked.join("|*|");
    axios({
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      url: window.serverUrl+`/social/user-infos.php`,
      data: {
        field: "cb_notifications",
        value: value
      }
    })
      //.then((r) => r.json())
      .then((resp) => {
        let data = resp.data;
        if (data.error === 401) {
          onLogin();
        } else {
          setNotificationsChanged(false);
          onNotifications(notifySubscriptions, notifyComments, notifyReplays);
        }
        setReady(true);
      })
      .catch((err) => {
        console.error("fetch problem", err);
        setReady(true);
        toast.error(t("settings.update_error"), {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: 0
        });
      });
  };
  const validateDescriptionForm = () => {
    return ready && descriptionChanged;
  };

  const validateNotificationsForm = () => {
    return ready && notificationsChanged;
  };

  const resetNotifications = () => {
    let splits = user.cb_notifications.split("|*|");
    setNotifySubscriptions(splits.includes("subscriptions") ? true : false);
    setNotifyComments(splits.includes("comments") ? true : false);
    setNotifyReplays(splits.includes("replays") ? true : false);
    setNotificationsChanged(false);
  };

  const onDescription = () => {
    toast.success(t("settings.description_updated"), {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: 0
    });
  };
  const onNotifications = () => {
    toast.success(t("settings.notifications_updated"), {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: 0
    });
  };

  useEffect(() => {
    //console.log("settings infos effect", user);
    if (user.error !== 401) {
      if (description === null) {
        setDescription((d) => user.cb_description);
        let splits = user.cb_notifications.split("|*|");
        setNotifySubscriptions((s) =>
          splits.includes("subscriptions") ? true : false
        );
        setNotifyComments((c) => (splits.includes("comments") ? true : false));
        setNotifyReplays((r) => (splits.includes("replays") ? true : false));
        setReady((r) => true);
      }
    }
  }, [user, description, dispatchUser]);

  return (
    <>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
      />
      <form
        onSubmit={handleDescriptionSubmit}
        className={"settings-infos separator d-flex " + (ready ? "ready" : "")}
      >
        <div className="infos-container d-flex flex-column">
          <section>{t("settings.description")}</section>
          <div style={{ position: "relative" }}>
            <TextareaAutosize
              onChange={onDescriptionChanged}
              value={description !== null ? description : ""}
              minRows="5"
              placeholder={t("settings.description_placeholder")}
            ></TextareaAutosize>
            <div className="remaining">
              {description !== null ? description.length : 0} / 500
            </div>
          </div>
          <div className="settings-actions d-flex justify-content-end">
            <Button
              disabled={!descriptionChanged}
              className="cancel"
              onClick={() => {
                setDescription(user.cb_description);
                setDescriptionChanged(false);
              }}
            >
              {t("replayApp.cancel")}
            </Button>
            <Button
              type="submit"
              disabled={!validateDescriptionForm()}
              className="update"
            >
              {t("settings.update")}
            </Button>
          </div>
        </div>
      </form>
      <form
        onSubmit={handleNotificationsSubmit}
        className={"settings-infos d-flex " + (ready ? "ready" : "")}
      >
        <div className="infos-container d-flex flex-column">
          <section>{t("settings.notifications")}</section>
          <div className="d-flex flex-column">
            <div className="d-flex"></div>
            <Form.Group controlId="notify-subscriptions">
              <Form.Check
                type="checkbox"
                checked={notifySubscriptions}
                onChange={(evt) => {
                  notifySubscriptionsChanged(evt);
                  setNotificationsChanged(true);
                }}
                label={t("settings.notify_subscriptions")}
              />
            </Form.Group>
            <Form.Group controlId="notify-comments">
              <Form.Check
                type="checkbox"
                checked={notifyComments}
                onChange={(evt) => {
                  notifyCommentsChanged(evt);
                  setNotificationsChanged(true);
                }}
                label={t("settings.notify_comments")}
              />
            </Form.Group>
            <Form.Group controlId="notify-replays">
              <Form.Check
                type="checkbox"
                checked={notifyReplays}
                onChange={(evt) => {
                  notifyReplaysChanged(evt);
                  setNotificationsChanged(true);
                }}
                label={t("settings.notify_replays")}
              />
            </Form.Group>
          </div>
          <div className="settings-actions d-flex justify-content-end">
            <Button
              disabled={!notificationsChanged}
              className="cancel"
              onClick={resetNotifications}
            >
              {t("replayApp.cancel")}
            </Button>
            <Button
              type="submit"
              disabled={!validateNotificationsForm()}
              className="update"
            >
              {t("settings.update")}
            </Button>
          </div>
        </div>
      </form>
    </>
  );
}

export default SettingsInfos;
